export const initialSettingsState = {
  username: "",
  password: "",
  password2: "",
  done: false,
  error: "",
  busy: false,
  users: [],
};
